<template>
  <v-container class="prevent-overflow">
    <h1>{{$t('insights.header')}}</h1>
    <custom-text msg="custom-text.insights" class="mt-2 mb-1"></custom-text>
    <div class="pt-4 subheading">{{$t('insights.subheading')}}</div>
    <v-card>
      <v-flex>
        <v-card-text>
          <v-container grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-select id="report_type" :label="$t('insights.type.title')" :items="translatedReportTypeItems"
                          v-model="reportType"/>
              </v-flex>
              <v-flex xs12 offset-sm1 sm5>
                <v-icon>mdi-information-variant</v-icon>
                {{$t('insights.type.help')}}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-flex>
      <v-flex>
        <v-card-text>
          <v-container grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12 sm6 :pb-4="$vuetify.breakpoint.xsOnly">
                <date-range-picker :date-range="dateRange"/>
                <span v-if="dateRangeInvalid" class="caption" style="color: red">{{$t('invalid_date_range')}}</span>
              </v-flex>
              <v-flex xs12 offset-sm1 sm5>
                <v-icon>mdi-information-variant</v-icon>
                {{$t('insights.daterange.help')}}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-flex>
    </v-card>
    <v-btn :disabled="report_loading"
           @click="downloadClicked"
           outline class="float-right mt-3" color="primary">
      <v-icon left>file_download</v-icon>
      {{$t(button_label)}}
    </v-btn>
  </v-container>
</template>

<script>
  import InsightsHeader from './InsightsHeader'
  import DateRangePicker from '../date/DateRangePicker'
  import moment from 'moment-es6'
  import DateFormat from '../../mixins/DateFormat'
  import Helpers from '../../mixins/Helpers'
  import { mapActions, mapState, mapGetters } from 'vuex'
  import { GET_INSIGHTS_REPORT, GET_GENERIC_REPORTS, GET_GENERIC_INSIGHTS_REPORT } from '../../store/action-types'
  import CustomText from '../help/CustomText'
  import {HAS_FEATURE_FLAG} from '../../store/getter-types'

  export default {
    components: {
      DateRangePicker,
      InsightsHeader,
      CustomText
    },
    name: 'insights-page',
    props: [],
    mixins: [DateFormat, Helpers],
    data () {
      return {
        dateRangeInvalid: false,
        reportType: 'usage',
        reportTypeItems: [
          {
            text: 'insights.type.items.usage',
            value: 'usage'
          },
          {
            text: 'insights.type.items.students',
            value: 'students'
          },
          {
            text: 'insights.type.items.alerts',
            value: 'alerts'
          },
          {
            text: 'insights.type.items.foundation',
            value: 'foundation'
          }
        ],
        dateRange: {
          startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD')
        }
      }
    },
    methods: {
      downloadClicked () {
        let diff = moment(this.dateRange.endDate).diff(moment(this.dateRange.startDate), 'days')
        if (diff >= 0) {
          this.dateRangeInvalid = false
          if (this.reportType.includes('generic')) {
            let id = this.reportType.substring(this.reportType.lastIndexOf('-') + 1)
            const reportPayload = {
              id: id,
              dateRange: this.dateRange,
              filename: this.$t(`insights.type.generic-report.${id}`)
            }
            this.fetchGenericReport(reportPayload)
          } else {
            const reportPayload = {
              type: this.reportType,
              dateRange: this.dateRange,
              filename: this.$t(`insights.type.items.${this.reportType}`)
            }
            this.fetchReport(reportPayload)
          }
        } else {
          this.dateRangeInvalid = true
        }
      },
      ...mapActions({
        fetchReport: GET_INSIGHTS_REPORT,
        fetchGenericReport: GET_GENERIC_INSIGHTS_REPORT
      })
    },
    computed: {
      ...mapState({
        report_loading: state => state.insights.report_loading,
        button_label: state => state.insights.button_label,
        moduleAlert: state => state.profile.module.alert,
        moduleInsights: state => state.profile.module.insights,
        functionAlertsReport: state => state.insights.functions.alertsReport,
        functionUserLogin: state => state.insights.functions.userLogin,
        optionEnableAlertsReport: state => state.insights.options.enable.alertsReport,
        optionEnableUserLoginReport: state => state.insights.options.enable.userLoginReport,
        genericReports: state => state.insights.generic_reports
      }),
      ...mapGetters({
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      translatedReportTypeItems () {
        let obj = !this.flagEnableAlertsReport
          ? this.reportTypeItems.filter(el => el.value !== 'alerts')
          : this.reportTypeItems
        if (this.flagUserLoginReport) {
          let logins = {
            text: 'insights.type.items.logins',
            value: 'logins'
          }
          obj.push(logins)
        }
        if (this.genericReports !== []) {
          this.genericReports.forEach(el => {
            let generic = {
              text: 'insights.type.generic-report.' + el.id,
              value: 'generic-' + el.reportDescription + '-' + el.id
            }
            obj.push(generic)
          })
        }
        return this.translateFields(obj)
      },
      flagEnableAlertsReport () {
        // Alerting/Alerts Report/Enable Alerts Reports
        return this.hasFeatureFlag(this.moduleAlert + '.' + this.functionAlertsReport + '.' + this.optionEnableAlertsReport)
      },
      flagUserLoginReport () {
        return this.hasFeatureFlag(this.moduleInsights + '.' + this.functionUserLogin + '.' + this.optionEnableUserLoginReport)
      }
    },
    watch: {},
    mounted () {
      this.$store.dispatch(GET_GENERIC_REPORTS)
    }
  }
</script>

<style scoped>
  .btn {
    float: left;
    min-width: 300px;
    margin: 0 0 16px 0;
  }

  @media only screen and (min-device-width : 0) and (max-device-width : 480px) {
    .btn {
      min-width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/insights/InsightsPage.vue